function happyCallDataReducer(state = { questionList : [] }, action) {
  
    switch (action.type) {
      
      case "FETCH_HAPPYCALL_ANSWERS":
        return {
          ...state,
          questionList: action.data
        };
          
      default:
        return state;
    }
  }
  
  export default happyCallDataReducer;